import React from "react";
import parse from "html-react-parser";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const ElectionNews = ({ electionNews }) => {
  return (
    <section className="max-md:pt-8 md:pl-8 max-md:border-t md:border-l border-dashed border-brown">
      <div className="flex justify-center">
        <LazyLoadImage
          effect="blur"
          src={electionNews?.imageUrl}
          width={electionNews?.styles?.width}
          className="rounded max-w-full"
          alt="Election News Image"
        />
      </div>
      <div className="mt-6 text-justify">{parse(electionNews.text)}</div>
    </section>
  );
};

export default ElectionNews;
